var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeechBubble29(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 5.5C2 6.31803 2.28063 7.0705 2.75088 7.66641C2.27833 8.32321 2 9.1291 2 10C2 12.2091 3.79086 14 6 14C6.40687 14 6.79956 13.9393 7.16948 13.8263C7.8935 14.5514 8.89437 15 10 15C11.3183 15 12.4877 14.3622 13.2164 13.3784C13.8858 13.7734 14.6665 14 15.5 14C17.9853 14 20 11.9853 20 9.5C20 8.32481 19.5495 7.25483 18.8118 6.45334C18.9331 6.15954 19 5.83759 19 5.5C19 4.11929 17.8807 3 16.5 3C15.6702 3 14.9348 3.40427 14.4801 4.02659C13.7924 2.81634 12.4915 2 11 2C9.87963 2 8.86685 2.46061 8.14069 3.2028C7.49903 2.46582 6.55391 2 5.5 2C3.567 2 2 3.567 2 5.5ZM6.5 9.5C5.94772 9.5 5.5 9.05229 5.5 8.5C5.5 7.94772 5.94772 7.5 6.5 7.5C7.05228 7.5 7.5 7.94772 7.5 8.5C7.5 9.05229 7.05228 9.5 6.5 9.5ZM10.5 9.5C9.94771 9.5 9.5 9.05229 9.5 8.5C9.5 7.94772 9.94771 7.5 10.5 7.5C11.0523 7.5 11.5 7.94772 11.5 8.5C11.5 9.05229 11.0523 9.5 10.5 9.5ZM15.5 8.5C15.5 9.05229 15.0523 9.5 14.5 9.5C13.9477 9.5 13.5 9.05229 13.5 8.5C13.5 7.94772 13.9477 7.5 14.5 7.5C15.0523 7.5 15.5 7.94772 15.5 8.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 17C20 18.1046 19.1046 19 18 19C16.8954 19 16 18.1046 16 17C16 15.8954 16.8954 15 18 15C19.1046 15 20 15.8954 20 17Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 21C22 21.5523 21.5523 22 21 22C20.4477 22 20 21.5523 20 21C20 20.4477 20.4477 20 21 20C21.5523 20 22 20.4477 22 21Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeechBubble29);
export default __webpack_public_path__ + "static/media/speech-bubble-29.b9dddaa3c88bf7bd7a55676d81528a00.svg";
export { ForwardRef as ReactComponent };